import { RegisterDrawer } from '@/pages/Register/RegisterDrawer'
import HeaderPublic from '@/shared/layouts/Header/HeaderPublic'
import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'

export const PublicLayout = () => {
  return (
    <Box>
      <HeaderPublic />
      <RegisterDrawer />
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
    </Box>
  )
}
